import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { CalendarViewWeek, Sync } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/custom';
import React from 'react';
import SchoolSuppliesImage from 'public/img/illustrations/school_supplies.svg';
import { SCHOOL_YEARS } from 'utils/links';
import { useIsUntisUser } from 'components/kratos';
import { importUntisTimetable, } from 'api/untis-timetable';
import { enqueueSnackbar } from 'notistack';
const EmptyTimetable = ({ onImportComplete, }) => {
    const { t } = useTranslation('timetable', { keyPrefix: 'emptyTimetable' });
    const isUntisUser = useIsUntisUser();
    const [syncing, setSyncing] = React.useState(false);
    const handleSync = () => {
        setSyncing(true);
        importUntisTimetable()
            .then(async (response) => {
            if (!response.ok) {
                const data = (await response.json());
                enqueueSnackbar(data.message || t('syncError'), {
                    variant: 'error',
                });
                return;
            }
            enqueueSnackbar(t('syncSuccess'), { variant: 'success' });
            /*
             * Trigger refetch of timetableExists instead of full page reload.
             * The parent component will re-render with CalendarForDashboard
             * once timetableExists returns true.
             */
            onImportComplete?.();
        })
            .catch(() => {
            enqueueSnackbar(t('syncError'), { variant: 'error' });
        })
            .finally(() => {
            setSyncing(false);
        });
    };
    // Non-Untis users: show "Create timetable" button
    if (!isUntisUser) {
        return (_jsxs(Stack, { alignItems: "center", spacing: 4, children: [_jsx(Box, { sx: {
                        backgroundImage: `url(${SchoolSuppliesImage})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        height: '25rem',
                        position: 'relative',
                        width: '100%',
                    } }), _jsx(Typography, { sx: { fontWeight: 700 }, variant: "h6", children: t('emptyTimetableText') }), _jsx(Button, { color: "secondary", href: SCHOOL_YEARS, startIcon: _jsx(CalendarViewWeek, {}), sx: { width: '10rem' }, variant: "contained", children: _jsx(Typography, { align: "center", children: t('createTimetableButton') }) })] }));
    }
    // Untis users: show sync button or spinner (background polling runs silently in parent)
    return (_jsxs(Stack, { alignItems: "center", spacing: 4, children: [_jsx(Box, { sx: {
                    backgroundImage: `url(${SchoolSuppliesImage})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    height: '25rem',
                    position: 'relative',
                    width: '100%',
                } }), syncing ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { size: 48, color: "secondary" }), _jsx(Typography, { sx: { fontWeight: 700 }, variant: "h6", children: t('autoSyncInProgress') }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: t('autoSyncHint') })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: { fontWeight: 700 }, variant: "h6", children: t('untisManualSyncText') }), _jsx(Button, { color: "secondary", onClick: handleSync, startIcon: _jsx(Sync, {}), sx: { width: 'auto' }, variant: "contained", children: _jsx(Typography, { align: "center", children: t('syncButton') }) })] }))] }));
};
export default EmptyTimetable;
